import { InjectionToken } from '@angular/core';

export enum WebpartRequestMessage {
    PUSH_ANALYTICS_EVENT = 'pushAnalyticsEvent',
    IS_MOBILE_CONTAINER = 'isMobileContainer',
    GIVE_PARAMETERS = 'giveParameters'
}

export const WEBPART_MESSAGING_IS_MOBILE = new InjectionToken<boolean>('WEBPART_MESSAGING_IS_MOBILE', {
    providedIn: 'root',
    factory: () => false
});
